import { Dispatch } from 'redux';
import { connect } from 'react-redux';

import { ClippingPlatformState } from 'store/clippingPlatformState';
import { getAll } from 'store/selectors';
import { ApiDataTypes } from 'api/apiDataTypes';
import { createActiveEventsRequestedAction } from 'actions/eventActions';
import EventsTable, { EventsTableClippingPresentation } from './eventTableForLiveAndHybrid';

function mapStateToProps(state: ClippingPlatformState) {
  return {
    events: getAll(state.entities.events),
    allEventsLoaded: state.appStatus.allLoaded[ApiDataTypes.ActiveEvents],
    clients: state.entities.clients.byId,
  };
}

function mapDispatchToProps(dispatch: Dispatch) {
  return {
    loadAllEvents: (c: EventsTableClippingPresentation) => dispatch(createActiveEventsRequestedAction(c, dispatch)),
  };
}

export const ActiveEventsTableClippingContainer = connect(mapStateToProps, mapDispatchToProps)(EventsTable);
